import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Layout } from '../Layout';

const ProtectedRoutes = ({ component: Component, ...rest }) => {
  const { path, location } = rest;
  const { isAuthenticated } = rest.auth;

  return isAuthenticated ? (
    <Layout exact path={path} component={Component} isAuthenticated={isAuthenticated} />
  ) : (
    <Redirect
      to={{
        pathname: '/login',
        state: { from: location }
      }}
    />
  );
};

ProtectedRoutes.propTypes = {
  component: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  auth: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    redirectTo: PropTypes.string
  }),
  redirectTo: PropTypes.string.isRequired
};

ProtectedRoutes.defaultProps = {
  auth: {
    loading: () => {},
    isAuthenticated: () => {},
    redirectTo: () => {}
  }
};

const mapStateToProps = state => ({
  auth: state.toJS().auth
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProtectedRoutes);
